<template>
	<ja-modal :show="show" class="installer-modal">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div class="modal-content">
			<h3 class="title">{{ $t('downloadInstaller') }}</h3>
			<div v-if="formData">
				<div class="grid">
					<div class="grid-row-2">
						<ja-dropdown
							ref="modalFirstDropdown"
							v-model="formData.facility"
							:label="$t('facilityLbl')"
							:options="facilities"
							name="facility"
							@input="choiceUpdated"
						></ja-dropdown>
					</div>
				</div>
				<div class="button-wrapper">
					<ja-button
						class="small"
						name="startDownload"
						:success="success"
						@click.native="startDownload"
					>
						{{ $t('download') }}
					</ja-button>
				</div>
			</div>
		</div>
	</ja-modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Dropdown from '../../ui/form/Dropdown';
import Button from '../../ui/Button';
import UserData from '@/mixins/UserData';
import DateFormat from '@/mixins/DateFormat';
import CloseButton from '../../ui/CloseButton';
import axios from 'axios';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	mixins: [UserData, DateFormat],

	props: {
		show: {
			type: Boolean,
			default: false
		},
		facilities: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			formData: null,
			success: false
		};
	},
	mounted() {
		if (this.$props.facilities.length) {
			this.setupModalData();
		}
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');
		},
		setupModalData() {
			const formData = {
				facilityName: this.facilities[0].name,
				facilityId: this.facilities[0].value
			};

			formData.facility = 0;

			this.formData = formData;
		},
		choiceUpdated() {
			let choice = this.facilities[this.formData.facility];

			this.formData.wholeArea = false;
			this.formData.facilityName = choice.name;
			this.formData.facilityId = choice.value;
		},
		startDownload() {
			if (this.success) {
				this.closeModal();
			} else {
				this.$emit('loadingStartForAdmin');

				const link = document.createElement('a');
				//link.href = process.env.VUE_APP_API_URL + '/StaticFiles/Installer.exe';
				link.href = process.env.VUE_APP_INSTALLER_URL;

				link.setAttribute('download', `Installer.exe`);
				link.click();

				axios({
					url: '/api/Data/GetApiKey',
					method: 'GET',
					reponseType: 'blob',
					params: {
						facilityId: this.formData.facilityId
					},
					withCredentials: true
				}).then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement('a');
					link.href = url;

					link.setAttribute(
						'download',
						`apiKey-${this.formData.facilityId}.json`
					);
					document.body.appendChild(link);
					link.click();
					this.success = true;
					this.$emit('loadingStopForAdmin');
				});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.installer-modal {
	::v-deep .modal {
		margin: auto;
		min-height: 240px;
		max-height: 768px;
		top: unset;
	}
	::v-deep.modal-content {
		border-radius: 8px;
	}
	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;
		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;
				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		.scrollbar {
			max-height: 720px;
		}
		height: 100%;
		width: 100%;
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-color: $container-bgcolor;
		// border: 1px solid $container-border;

		h3 {
			margin: 16px;
			text-align: center;
		}

		.grid {
			display: flex;
			flex-direction: column;
			padding: 0 32px 32px 32px;

			.grid-row-1 {
				display: flex;
				margin-bottom: 16px;
				> * {
					flex: 0 0 100%;
				}
			}

			.grid-row-2 {
				display: flex;
				align-items: flex-start;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				> * {
					flex: 0 0 calc(50% - 8px);

					&:first-child {
						margin-right: 16px;
					}
				}
				&.align-bottom {
					align-items: flex-end;
				}
			}

			.grid-col-3 {
				display: flex;
				align-items: flex-end;

				> :first-child {
					margin-right: 16px;
				}

				.grid-cell-2 {
					flex: 0 0 calc(66.66% - 8px);
				}

				.grid-cell-1 {
					flex: 0 0 calc(33.33% - 8px);
				}
			}
		}

		.button-wrapper {
			text-align: center;
			margin-bottom: 64px;
		}
	}

	.text-align--center {
		text-align: center;
	}
}
</style>
